module.exports = __webpack_public_path__ + "img/3.a427dc87.jpg";